(function () {
    // =========================
    // Config
    // =========================
    const IMPRESSION_THRESHOLD = 0.5; // 50%見えたら view とみなす

    // =========================
    // Utils
    // =========================
    function getBaseItemIdFromUrl() {
        var match = window.location.pathname.match(/\/products\/([^\/\?]+)/);
        return match ? match[1] : null;
    }

    function publishEvent(eventName, payload) {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
            const res = Shopify.analytics.publish(eventName, payload);
            if (!res) console.error("Cannot send event", eventName, payload);
        }
    }

    function toElementTarget(t) {
        if (t && t.nodeType === 3) return t.parentElement;
        return t instanceof Element ? t : null;
    }

    // =========================
    // Impression tracking (ai_recommend_view)
    // =========================
    const viewedKeySet = new Set();

    function buildViewPayload(article) {
        var baseItemId = getBaseItemIdFromUrl();
        var targetItemId = article.getAttribute("data-target-item-id");
        if (!baseItemId || !targetItemId) return null;

        return {
            event: "ai_recommend_view",
            base_item_id: baseItemId,
            target_item_id: targetItemId,
        };
    }

    function markAndSendView(article) {
        var payload = buildViewPayload(article);
        if (!payload) return;

        var key = payload.base_item_id + "::" + payload.target_item_id;
        if (viewedKeySet.has(key)) return;

        viewedKeySet.add(key);
        publishEvent("ai_recommend_view", payload);
    }

    function initImpressionTracking() {
        var articles = Array.prototype.slice.call(
            document.querySelectorAll(".thothai-recommended-item")
        );
        if (!articles.length) return;

        if (!("IntersectionObserver" in window)) {
            var onScroll = function () {
                articles.forEach(function (a) {
                    var payload = buildViewPayload(a);
                    if (!payload) return;
                    var key = payload.base_item_id + "::" + payload.target_item_id;
                    if (viewedKeySet.has(key)) return;
                    var rect = a.getBoundingClientRect();
                    if (rect.top < window.innerHeight && rect.bottom > 0) {
                        markAndSendView(a);
                    }
                });
            };
            window.addEventListener("scroll", onScroll, { passive: true });
            window.addEventListener("resize", onScroll);
            onScroll();
            return;
        }

        var io = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    if (entry.intersectionRatio >= IMPRESSION_THRESHOLD) {
                        markAndSendView(entry.target);
                        io.unobserve(entry.target);
                    }
                });
            },
            { root: null, threshold: [0, IMPRESSION_THRESHOLD, 1.0] }
        );

        articles.forEach(function (a) {
            io.observe(a);
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initImpressionTracking);
    } else {
        initImpressionTracking();
    }

    // =========================
    // Click tracking (ai_recommend_click)
    // =========================
    document.addEventListener(
        "click",
        function (e) {
            var targetEl = toElementTarget(e.target);
            if (!targetEl) return;

            var link = targetEl.closest(".thothai-recommended-link");
            if (!link) return;

            var article = link.closest(".thothai-recommended-item");
            if (!article) return;

            var baseItemId = getBaseItemIdFromUrl();
            var targetItemId = article.getAttribute("data-target-item-id");
            var lang = link.getAttribute("data-lang") || null;

            if (!baseItemId || !targetItemId) return;

            publishEvent("ai_recommend_click", {
                base_item_id: baseItemId,
                target_item_id: targetItemId,
                lang: lang,
            });
        },
        true
    );

    // =========================
    // WorldShoppingBIZ tracking (wbiz_add_to_cart)
    // =========================
    document.addEventListener(
        "click",
        function (e) {

            var path = typeof e.composedPath === "function" ? e.composedPath() : [];
            if (!path.length) return;

            var addToCartButton = path.find(function (el) {
                return el && el.nodeType === 1 && el.id === "zigzag-test__item-add-to-cart";
            });

            if (!addToCartButton) return;

            var root = typeof addToCartButton.getRootNode === "function" ? addToCartButton.getRootNode() : null;
            if (!root || typeof root.querySelector !== "function") return;

            var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
            if (!meta || !meta.product) {
                console.log("[WBIZ] ❌ ShopifyAnalytics.meta.product not found");
                return;
            }

            var product = meta.product;
            var selectedVariantId = String(meta.selectedVariantId || "");
            var variant = (product.variants || []).find(function (v) {
                return String(v.id) === selectedVariantId;
            }) || (product.variants || [])[0];

            if (!variant) return;

            var quantityEl = root.querySelector('select[name="quantity"]');
            var quantity = quantityEl ? Number(quantityEl.value || 1) : 1;
            var price = typeof variant.price === "number" ? variant.price / 100 : 0;

            var payload = {
                currency: meta.currency || "",
                value: price * quantity,
                items: [{
                    item_id: product.id ? String(product.id) : undefined,
                    item_name: variant.name || undefined,
                    item_brand: product.vendor || undefined,
                    item_category: product.type || undefined,
                    item_variant: variant.id ? String(variant.id) : undefined,
                    item_sku: variant.sku || undefined,
                    item_handle: product.handle || undefined,
                    price: price,
                    quantity: quantity,
                }],
                traffic_type: "worldshopping",
            };

            console.log("[WBIZ] 🚀 sending event", payload);
            publishEvent("wbiz_add_to_cart", payload);
        },
        true
    );
})();